import React from 'react';
import { Button, Icon } from '../../../pages/DesignSystem';

interface PlanningEmptyStateProps {
  type: 'week' | 'day';
  onCreateEvent: () => void;
  onImport?: () => void;
}

const PlanningEmptyState: React.FC<PlanningEmptyStateProps> = ({ type, onCreateEvent, onImport }) => {
  if (type === 'day') {
    return (
      <div className="planning-empty-state planning-empty-state--day">
        <p className="planning-empty-state__text">No events</p>
      </div>
    );
  }

  return (
    <div className="planning-empty-state planning-empty-state--week">
      <h3 className="planning-empty-state__title">No events this week</h3>
      <p className="planning-empty-state__subtitle">Your week is wide open!</p>
      <div className="planning-empty-state__actions">
        <Button variant="primary" size="md" onClick={onCreateEvent}>
          <Icon name="Plus" size={18} />
          Create your first event
        </Button>
        {onImport && (
          <Button variant="secondary" size="md" onClick={onImport}>
            <Icon name="Upload" size={18} />
            Import from Excel / Photo
          </Button>
        )}
      </div>
    </div>
  );
};

export default React.memo(PlanningEmptyState);
